import { FC } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import TableChartIcon from '@mui/icons-material/TableChart';

interface DataTableHeaderProps {
    title?: string;
    icon?: React.ReactNode;
}

export const DataTableHeader: FC<DataTableHeaderProps> = ({ title, icon }) => {
    if (!title) return null;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    mb: 2,
                }}
            >
                {icon || <TableChartIcon color="primary" />}
                <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                        fontWeight: 600,
                        color: 'text.primary',
                    }}
                >
                    {title}
                </Typography>
            </Box>
            <Divider sx={{ mb: 2 }} />
        </>
    );
};

